import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'app/core/auth/authentication.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  emailSent = false;

  email: string;

  constructor(private _authService: AuthenticationService) {}

  get isAuthenticated() {
    return this._authService.isAuthenticated();
  }

  ngOnInit(): void {
    if (this.isAuthenticated) {
      this.email = this._authService.currentUser.email;
    }
  }

  resetPassword() {
    this.emailSent = true;
    this._authService.resetPassword(this.email);
  }
}
